import { useEffect, useRef } from 'react';
import { useIsComponentStillOnItsPage } from '@namespace/cms';
import { useI18n } from '@namespace/i18n';
import { sportsbookActions } from '../../store';

const { FETCH_POPULAR_BETS_EVENTS } = sportsbookActions;

type UseFetchPopularEventsProps = {
  sportId: number;
  lineKey: string;
  categoryId: number;
};

export const useFetchPopularEvents = ({
  sportId,
  lineKey,
  categoryId
}: UseFetchPopularEventsProps) => {
  const { language: lang, timezone } = useI18n();
  const checkIsComponentStillOnItsPage = useIsComponentStillOnItsPage();
  const lineKeyRef = useRef<string | null>(lineKey);

  useEffect(() => {
    lineKeyRef.current = lineKey;

    return () => {
      lineKeyRef.current = null;
    };
  }, [lineKey]);

  useEffect(() => {
    if (!checkIsComponentStillOnItsPage()) {
      return;
    }

    if (sportId) {
      FETCH_POPULAR_BETS_EVENTS({
        sportId,
        lineKey,
        lang,
        categoryId,
        lineKeyRef
      });
    }
  }, [
    lang,
    sportId,
    categoryId,
    lineKey,
    timezone,
    checkIsComponentStillOnItsPage
  ]);
};
